import { render, staticRenderFns } from "./DepartmentTagIcon.vue?vue&type=template&id=7c6d9838"
import script from "./DepartmentTagIcon.vue?vue&type=script&lang=js"
export * from "./DepartmentTagIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports